<template>
  <div>
    <div>
      <div class="box box-primary">
        <div class="box-body">
          <form action="#" method="post">
            <fieldset>
              <!-- <legend>Login Information</legend> -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-12 col-md-5 col-lg-4">
                    <div class="form-group">
                      <label for="">{{
                        $t("apartmentBooking.checkInDate")
                      }}</label>
                      <div style="display: flex">
                        <div style="width: 60%">
                          <date-picker
                            class="form-control"
                            :config="checkInDatePickerOptions"
                            placeholder="DD-MM-YYYY"
                            v-model="apartmentBookingData.dateCheckIn"
                          ></date-picker>
                        </div>
                        <div style="width: 40%">
                          <date-picker
                            class="form-control"
                            :config="timePickerOptions"
                            placeholder="HH:mm"
                            v-model="apartmentBookingData.timeCheckIn"
                          ></date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-5 col-lg-4">
                    <div class="form-group">
                      <label for="">{{
                        $t("apartmentBooking.checkOutDate")
                      }}</label>
                      <div style="display: flex">
                        <div style="width: 60%">
                          <date-picker
                            class="form-control"
                            :config="checkOutDatePickerOptions"
                            placeholder="DD-MM-YYYY"
                            v-model="apartmentBookingData.dateCheckOut"
                          ></date-picker>
                        </div>
                        <div style="width: 40%">
                          <date-picker
                            class="form-control"
                            :config="timePickerOptions"
                            placeholder="HH:mm"
                            v-model="apartmentBookingData.timeCheckOut"
                          ></date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-ms-12 col-md-12 col-lg-12">
                    <div class="form-group">
                      <label class="">{{
                        $t("apartmentBooking.bookingNote")
                      }}</label>
                      <textarea
                        :placeholder="$t('apartmentBooking.bookingNote')"
                        type="text"
                        class="form-control"
                        cols="30"
                        rows="6"
                        v-model="apartmentBookingData.bookingNote"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend>{{ $t("apartmentBooking.userBookingInfo") }}</legend>
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="" class="control-label required">{{
                        $t("apartmentBooking.customerName")
                      }}</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="customerBookingData.customerName"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="" class="control-label required">{{
                        $t("common.phone")
                      }}</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="customerBookingData.customerPhone"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="" class="control-label required">{{ $t("common.email") }}</label>
                      <input
                        class="form-control"
                        type="email"
                        v-model="customerBookingData.customerEmail"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="">{{ $t("customer.gender") }}</label>
                      <select
                        v-model="customerBookingData.customerGender"
                        class="form-control"
                      >
                        <option
                          v-for="gender in genderList"
                          v-bind:value="gender.id"
                          :key="gender.id"
                          >{{ $t(gender.text) }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="">{{
                        $t("customer.identificationnumber")
                      }}</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="customerBookingData.identificationnumber"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="">{{
                        $t("apartmentBooking.dateCreateIdentificationnumber")
                      }}</label>
                      <date-picker
                        class="form-control"
                        v-model="
                          customerBookingData.dateCreateIdentificationnumber
                        "
                        :config="datePickerOptions"
                      ></date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="">{{ $t("customer.dob") }}</label>
                      <date-picker
                        class="form-control"
                        v-model="customerBookingData.customerDob"
                        :config="datePickerOptions"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="">{{ $t("customer.country") }}</label>
                      <b-form-select
                        :options="countryList"
                        v-model="customerBookingData.customerCountry"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="">{{ $t("customer.address") }}</label>
                  <textarea
                    type="text"
                    class="form-control"
                    cols="30"
                    rows="4"
                    v-model="customerBookingData.customerAddress"
                  />
                </div>
              </div>
              <div class="col-sm-12" style="margin-bottom: 15px">
                <!-- <div class="form-group"> -->
                <button
                  type="button"
                  class="btn btn-labeled btn-primary pull-right"
                  @click="onSaveCustomerBooking"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-check"></i>
                  </span>
                  {{ $t("apartmentBooking.updateCustomerBooking") }}
                </button>
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  style="margin-right: 10px"
                  @click="onAddNewCustomerBooking"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-plus"></i>
                  </span>
                  {{ $t("common.reset") }}
                </button>
                <!-- </div> -->
              </div>
              <div class="col-sm-12" style="margin-bottom: 20px">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="">{{
                        $t("apartmentBooking.customerList")
                      }}</label>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div>
                      <b-table
                        :items="customerInBookingList"
                        :fields="customerInBookingFields"
                        class="mt-3"
                        responsive
                        outlined
                      >
                        <template #head()="scope">
                          <div>{{ $t(scope.label) }}</div>
                        </template>
                        <template #cell(status)="row">
                          <span>{{ $t(row.item.status) }}</span>
                        </template>
                        <template #cell(isManCustomerBooking)="row">
                          <div class="form-check">
                            <input
                              class="form-check-input position-static"
                              type="radio"
                              name="blankRadio"
                              id="blankRadio1"
                              v-model="row.item.isManCustomerBooking"
                              :value="true"
                              @change="onChangeMainBooking(row.index)"
                            />
                          </div>
                        </template>
                        <template #cell(actions)="row">
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            style="margin-left: 6px;"
                            @click="onEditUserInBooking(row.item, row.index)"
                          >
                            <i class="glyphicon glyphicon-edit"></i>
                          </button>
                          <!-- <div class="btn-group">
                            <button
                              type="button"
                              class="btn btn-danger dropdown-toggle"
                              data-toggle="dropdown"
                              aria-expanded="true"
                            >
                              <i class="fa fa-fw fa-ellipsis-h"></i>
                            </button>
                            <ul class="dropdown-menu" style="min-width: 50px;">
                              <li>
                                <button
                                  type="button"
                                  class="btn btn-primary btn-sm"
                                  style="margin-left: 6px;"
                                  @click="
                                    onEditUserInBooking(row.item, row.index)
                                  "
                                >
                                  <i class="glyphicon glyphicon-edit"></i>
                                </button>
                              </li>
                              <li>
                                <button
                                  class="btn btn-danger btn-sm"
                                  style="margin-left: 6px;"
                                  @click="onOpenDelete(row)"
                                >
                                  <i class="glyphicon glyphicon-trash"></i>
                                </button>
                              </li>
                            </ul>
                          </div> -->
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend>{{ $t("apartment.title") }}</legend>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12" style="margin-bottom: 15px">
                    <button
                      type="button"
                      class="btn btn-labeled btn-success pull-right"
                      @click="onSelectApartment"
                    >
                      <span class="btn-label">
                        <i class="glyphicon glyphicon-check"></i>
                      </span>
                      {{ $t("common.addnew") }}
                    </button>
                  </div>
                  <div class="col-md-12" style="margin-bottom: 20px">
                    <div>
                      <b-table
                        :items="apartmentInBookingList"
                        :fields="apartmentInBookingFields"
                        class="mt-3"
                        responsive
                        outlined
                      >
                        <template #head()="scope">
                          <div>{{ $t(scope.label) }}</div>
                        </template>
                        <template #cell(status)="row">
                          <span>{{ $t(row.item.status) }}</span>
                        </template>
                        <template #cell(actions)="row">
                          <div class="btn-group">
                            <button
                              type="button"
                              class="btn btn-danger dropdown-toggle"
                              data-toggle="dropdown"
                              aria-expanded="true"
                            >
                              <i class="fa fa-fw fa-ellipsis-h"></i>
                            </button>
                            <ul
                              class="dropdown-menu"
                              style="min-width: 50px;height: 80px;"
                            >
                              <li>
                                <button
                                  class="btn btn-primary btn-sm"
                                  style="margin-left: 6px;"
                                  @click="onOpenEditApartmentBooking(row.item)"
                                >
                                  <i class="glyphicon glyphicon-edit"></i>
                                </button>
                              </li>
                              <!-- <li>
                                <button
                                  class="btn btn-danger btn-sm"
                                  style="margin-left: 6px;"
                                  @click="onOpenDelete(row)"
                                >
                                  <i class="glyphicon glyphicon-trash"></i>
                                </button>
                              </li> -->
                            </ul>
                          </div>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
          <!--  -->
        </div>
        <div class="box-footer">
          <button
            type="button"
            class="btn btn-labeled btn-danger"
            @click="onCallBackBookingList"
            style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
            {{ $t("common.back") }}
          </button>
          <button
            v-if="apartmentBookingData.status !== BookingActionEnum.CANCEL"
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="onSaveBooking"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.save") }}
          </button>
        </div>
      </div>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <!--  -->
    <div
      class="modal fade"
      :ref="`modal-apartment-in-booking-list`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="onCloseApartmentInBookingModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t() }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-12 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label for="">{{
                        $t("apartmentBooking.checkInDate")
                      }}</label>
                      <div style="display: flex">
                        <div style="width: 60%">
                          <date-picker
                            class="form-control"
                            :config="datePickerOptions"
                            placeholder="DD-MM-YYYY"
                            v-model="apartmentBookingSearch.dateCheckIn"
                          ></date-picker>
                        </div>
                        <div style="width: 40%">
                          <date-picker
                            class="form-control"
                            :config="timePickerOptions"
                            placeholder="HH:mm"
                            v-model="apartmentBookingSearch.timeCheckIn"
                          ></date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label for="">{{
                        $t("apartmentBooking.checkOutDate")
                      }}</label>
                      <div style="display: flex">
                        <div style="width: 60%">
                          <date-picker
                            class="form-control"
                            :config="datePickerOptions"
                            placeholder="DD-MM-YYYY"
                            v-model="apartmentBookingSearch.dateCheckOut"
                          ></date-picker>
                        </div>
                        <div style="width: 40%">
                          <date-picker
                            class="form-control"
                            :config="timePickerOptions"
                            placeholder="HH:mm"
                            v-model="apartmentBookingSearch.timeCheckOut"
                          ></date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-sm-12 col-md-8 col-lg-8"></div>
                  <div class="col-sm-12 col-md-4 col-lg-4">
                    <div class="form-group">
                      <label for=""></label>
                      <button
                        type="button"
                        class="btn btn-labeled btn-primary pull-right"
                        @click="onSearchApartmentTypeBooking"
                        style="margin-right: 5px;"
                      >
                        <span class="btn-label">
                          <i class="glyphicon glyphicon-search"></i>
                        </span>
                        {{ $t("common.search") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="margin-top: 15px">
              <div class="col-md-12">
                <div>
                  <b-table
                    :items="apartmentSearchBookingItem"
                    :fields="apartmentSearchBookingFields"
                    class="mt-3"
                    responsive
                    outlined
                    selectable
                    @row-selected="onRowSelected"
                    select-mode="multi"
                    ref="apartmentSearchInBooking"
                  >
                    <template #head()="scope">
                      <div>{{ $t(scope.label) }}</div>
                    </template>
                    <template #cell(numberOfRoomChoose)="row">
                      <input
                        type="number"
                        class="form-control"
                        v-model="row.item.numberOfRoomChoose"
                        @input="
                          inputApartmentNumberOfRoom(
                            row.item.quantity,
                            row.item.numberOfRoomChoose
                          )
                        "
                      />
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCloseApartmentInBookingModal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onSelectApartmentBooking"
            >
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </div>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
  </div>
</template>

<script>
// import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import { mapGetters, mapActions } from "vuex";
import datePicker from "vue-bootstrap-datetimepicker";
import moment from "moment";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils';
import constantsData from "@/lib/constantsData";
import BookingActionEnum from "@/enum/bookingActionEnum";

export default {
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading,
    "date-picker": datePicker
  },
  data() {
    return {
      BookingActionEnum: BookingActionEnum,
      isLoading: false,
      datePickerOptions: {
        format: "DD-MM-YYYY",
        useCurrent: false
        // minDate: moment()
      },
      checkInDatePickerOptions: {
        format: "DD-MM-YYYY",
        useCurrent: false,
        minDate: moment()
      },
      checkOutDatePickerOptions: {
        format: "DD-MM-YYYY",
        useCurrent: false,
        minDate: moment()
      },
      timePickerOptions: {
        format: "HH:mm",
        useCurrent: true
      },
      //
      countryList: [],
      apartmentBookingData: {
        id: 0,
        dateCheckIn: null,
        timeCheckIn: null,
        dateCheckOut: null,
        timeCheckOut: null,
        bookingNote: null,
        status: null
      },

      customerBookingData: {
        id: 0,
        customerName: null,
        customerPhone: null,
        customerEmail: null,
        customerGender: 1,
        identificationnumber: null,
        dateCreateIdentificationnumber: null,
        customerDob: null,
        customerCountry: null,
        customerAddress: null
      },
      genderList: constantsData.genderTypes,
      customerInBookingList: [],
      customerInBookingFields: [
        {
          label: "common.nonumber",
          key: "nonumber",
          class: "text-center "
        },
        {
          label: "apartmentBooking.isManCustomer",
          key: "isManCustomerBooking",
          class: "text-center "
        },
        {
          label: "apartmentBooking.customerName",
          key: "customerName",
          class: "text-center "
        },
        {
          label: "user_guest.identification",
          key: "identificationnumber",
          class: "text-center "
        },
        {
          label: "customer.phone",
          key: "customerPhone",
          class: "text-center "
        },
        {
          label: "common.email",
          key: "customerEmail",
          class: "text-center "
        },
        {
          label: "case.status",
          key: "status",
          class: "text-center "
        },
        { key: "actions", label: "common.action" }
      ],
      indexUserInBooking: null,
      // apartment in booking
      apartmentBookingSearch: {
        dateCheckIn: null,
        timeCheckIn: null,
        dateCheckOut: null,
        timeCheckOut: null
      },
      apartmentInBookingList: [],
      apartmentInBookingFields: [
        {
          label: "common.nonumber",
          key: "nonumber",
          class: "text-center "
        },
        {
          label: "apartmentType.title",
          key: "apartmentType",
          class: "text-center "
        },
        {
          label: "apartmentType.adults",
          key: "adults",
          class: "text-center "
        },
        {
          label: "apartmentType.children",
          key: "children",
          class: "text-center "
        },
        {
          label: "apartmentBooking.quantity",
          key: "numberOfRoomChoose",
          class: "text-center "
        }
        // {
        //   label: "apartmentBooking.checkInDate",
        //   key: "checkInDate",
        //   sortable: true,
        //   class: "text-center "
        // },
        // {
        //   label: "apartmentBooking.checkOutDate",
        //   key: "checkOutDate",
        //   sortable: true,
        //   class: "text-center "
        // },
        // { key: "actions", label: "common.action", sortable: false }
      ],
      // on search apartment booking
      apartmentSearchBookingItem: [],
      apartmentSearchBookingFields: [
        {
          label: "common.nonumber",
          key: "nonumber",
          class: "text-center "
        },
        {
          label: "apartmentType.title",
          key: "apartmentType",
          class: "text-center "
        },
        {
          label: "apartmentType.adults",
          key: "adults",
          class: "text-center "
        },
        {
          label: "apartmentType.children",
          key: "children",
          class: "text-center "
        },
        {
          label: "apartmentBooking.quantity",
          key: "quantity",
          class: "text-center "
        },
        {
          label: "apartmentBooking.numberOfRoomChoose",
          key: "numberOfRoomChoose",
          class: "text-center "
        }
      ],
      apartmentBookingSelectList: []
    };
  },

  watch: {
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_SNACK_BAR",
      "GET_APARTMENT_BOOKING_DETAIL_DATA"
    ]),
    account_fullname: function() {
      return `${this.GET_ACCOUNT_DATA.lastname} ${this.GET_ACCOUNT_DATA.firstname}`;
    }
  },

  methods: {
    onCallBackBookingList: function() {
      window.history.back();
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onShowError: function(mess) {
      this.ON_SHOW_TOAST({
        message: mess,
        styleType: "danger"
      });
    },
    onShowSuccess: function(mess) {
      this.ON_SHOW_TOAST({
        message: mess,
        styleType: "success"
      });
    },
    // date picker
    onChangeCheckInDate: function(value) {
      this.checkOutDatePickerOptions.minDate = value;
      // this.apartmentBookingData.dateCheckOut = this.apartmentBookingData.dateCheckOut
    },
    onChangeMinDateCheckInDate: function(value) {
      this.checkInDatePickerOptions.minDate = moment(value, "DD-MM-YYYY");
    },
    onChangeMinDateCheckOutDate: function(value) {
      this.checkOutDatePickerOptions.minDate = value;
    },
    // customer booking
    onAddNewCustomerBooking: function() {
      this.customerBookingData = {
        id: 0,
        customerName: null,
        customerPhone: null,
        customerEmail: null,
        customerGender: 1,
        identificationnumber: null,
        dateCreateIdentificationnumber: null,
        customerDob: null,
        customerCountry: null,
        customerAddress: null
      };
      this.indexUserInBooking = null;
    },
    onSaveCustomerBooking: function() {
      if (utils.isEmptyString(this.customerBookingData.customerName)) {
        this.onShowError(this.$t("apartmentBooking.customerName"));
      } else if (utils.isEmptyString(this.customerBookingData.customerPhone)) {
        this.onShowError(this.$t("customer.phone"));
      } else if (utils.isEmptyString(this.customerBookingData.customerEmail)) {
        this.onShowError(this.$t('common.email'))
      } else {
        if (
          this.customerBookingData.id === 0 &&
          this.indexUserInBooking === null
        ) {
          let item = {
            id: this.customerBookingData.id,
            nonumber: this.customerInBookingList.length + 1,
            customerName: this.customerBookingData.customerName,
            customerPhone: this.customerBookingData.customerPhone,
            customerEmail: this.customerBookingData.customerEmail,
            customerGender: this.customerBookingData.customerGender,
            identificationnumber: this.customerBookingData.identificationnumber,
            dateCreateIdentificationnumber: this.customerBookingData
              .dateCreateIdentificationnumber,
            customerDob: this.customerBookingData.customerDob,
            customerCountry: this.customerBookingData.customerCountry,
            customerAddress: this.customerBookingData.customerAddress,
            isManCustomerBooking: this.getIsManBooking()
          };
          this.customerInBookingList.push(item);
          // on refresh data
          this.customerBookingData = {
            id: 0,
            customerName: null,
            customerPhone: null,
            customerEmail: null,
            customerGender: 1,
            identificationnumber: null,
            dateCreateIdentificationnumber: null,
            customerDob: null,
            customerCountry: null,
            customerAddress: null
          };
          this.onShowSuccess(
            this.$t("apartmentBooking.showSuccessUpdateCustomerBooking")
          );
          this.indexUserInBooking = null;
        } else {
          let userEdit = this.customerInBookingList[this.indexUserInBooking];
          userEdit.customerName = this.customerBookingData.customerName;
          userEdit.customerPhone = this.customerBookingData.customerPhone;
          userEdit.customerEmail = this.customerBookingData.customerEmail;
          userEdit.customerGender = this.customerBookingData.customerGender;
          userEdit.identificationnumber = this.customerBookingData.identificationnumber;
          userEdit.dateCreateIdentificationnumber = this.customerBookingData.dateCreateIdentificationnumber;
          userEdit.customerDob = this.customerBookingData.customerDob;
          userEdit.customerCountry = this.customerBookingData.customerCountry;
          userEdit.customerAddress = this.customerBookingData.customerAddress;
          // on refresh data
          this.customerBookingData = {
            id: 0,
            customerName: null,
            customerPhone: null,
            customerEmail: null,
            customerGender: 1,
            identificationnumber: null,
            dateCreateIdentificationnumber: null,
            customerDob: null,
            customerCountry: null,
            customerAddress: null
          };
          this.onShowSuccess(
            this.$t("apartmentBooking.showSuccessUpdateCustomerBooking")
          );
          this.indexUserInBooking = null;
        }
      }
    },
    getIsManBooking: function() {
      if (this.customerInBookingList.length === 0) {
        return true;
      } else {
        let index = this.customerInBookingList.findIndex(
          x => x.isManCustomerBooking === true
        );
        if (index !== -1) {
          return false;
        } else {
          return true;
        }
      }
    },
    onChangeMainBooking: function(value) {
      this.customerInBookingList.filter(x => x);
      for (let i = 0; i < this.customerInBookingList.length; i++) {
        if (i !== value) {
          this.customerInBookingList[i].isManCustomerBooking = false;
        }
      }
    },
    onEditUserInBooking: function(data, index) {
      this.customerBookingData = {
        id: data.id,
        customerName: data.customerName,
        customerPhone: data.customerPhone,
        customerEmail: data.customerEmail,
        customerGender: data.customerGender,
        identificationnumber: data.identificationnumber,
        dateCreateIdentificationnumber: data.dateCreateIdentificationnumber,
        customerDob: data.customerDob,
        customerCountry: data.customerCountry,
        customerAddress: data.customerAddress
      };
      this.indexUserInBooking = index;
    },
    // apartment booking
    onShowApartmentInBookingModal: function() {
      $(this.$refs[`modal-apartment-in-booking-list`]).modal("show");
    },
    onCloseApartmentInBookingModal: function() {
      $(this.$refs[`modal-apartment-in-booking-list`]).modal("hide");
    },
    onSelectApartment: function() {
      this.onShowApartmentInBookingModal();
      this.apartmentBookingSearch.dateCheckIn = this.apartmentBookingData.dateCheckIn;
      this.apartmentBookingSearch.timeCheckIn = this.apartmentBookingData.timeCheckIn;
      this.apartmentBookingSearch.dateCheckOut = this.apartmentBookingData.dateCheckOut;
      this.apartmentBookingSearch.timeCheckOut = this.apartmentBookingData.timeCheckOut;
      this.onSearchApartmentTypeBooking();
      // if (this.apartmentInBookingList.length > 0) {
      //   await this.getRowsSelected(this.apartmentInBookingList);
      // }
    },
    onRowSelected: function(items) {
      this.apartmentBookingSelectList = items;
    },
    getRowsSelected: function(arrayResult) {
      arrayResult.forEach(data => {
        let index = this.apartmentSearchBookingItem.findIndex(
          x => x.id === data.apartmentTypeId
        );
        if (index !== -1) {
          this.$refs.apartmentSearchInBooking.selectRow(index);
          this.apartmentSearchBookingItem[index].numberOfRoomChoose = parseInt(
            data.numberOfRoomChoose
          );
        }
      });
    },
    inputApartmentNumberOfRoom(apartmentQuantity, numberOfRoomChoose) {
      if (utils.isEmptyString(numberOfRoomChoose)) {
        this.onShowError(this.$t("apartmentBooking.numberOfRoomChoose"));
      } else if (parseInt(numberOfRoomChoose) < 0) {
        this.onShowError(this.$t("apartmentBooking.numberOfRoomChoose"));
      } else if (parseInt(numberOfRoomChoose) > apartmentQuantity) {
        this.onShowError(
          this.$t("apartmentBooking.numberRoomGreaterTotalRoom")
        );
      }
    },
    onSelectApartmentBooking: function() {
      if (this.apartmentBookingSelectList.length === 0) {
        this.onShowError(
          this.$t("apartmentBooking.errorSelectApartmentBookingList")
        );
      } else {
        let index = this.apartmentBookingSelectList.findIndex(
          x => utils.isEmptyString(x.numberOfRoomChoose) ||
            (!utils.isEmptyString(x.numberOfRoomChoose) && parseInt(x.numberOfRoomChoose) <= 0)
        );
        if (index !== -1) {
          this.onShowError(this.$t("apartmentBooking.numberOfRoomChoose"));
        } else {
          this.apartmentInBookingList = [];
          for (let i = 0; i < this.apartmentBookingSelectList.length; i++) {
            let data = this.apartmentBookingSelectList[i];

            let item = {
              id: 0,
              nonumber: i + 1,
              apartmentTypeId: data.id,
              apartmentType: data.apartmentType,
              adults: data.adults,
              children: data.children,
              numberOfRoomChoose: data.numberOfRoomChoose
            };
            this.apartmentInBookingList.push(item);
          }
          this.onCloseApartmentInBookingModal();
        }
      }

      // if (this.apartmentBookingSelectList.length === 0) {
      //   this.onShowError(
      //     this.$t("apartmentBooking.errorSelectApartmentBookingList")
      //   );
      // } else {
      //   let index = this.apartmentBookingSelectList.findIndex(
      //     x => utils.isEmptyString(x.numberOfRoomChoose) ||
      //       (!utils.isEmptyString(x.numberOfRoomChoose) && parseInt(x.numberOfRoomChoose) <= 0)
      //   );
      //   if (index !== -1) {
      //     this.onShowError(this.$t("apartmentBooking.numberOfRoomChoose"));
      //   } else {
      //     for (let i = 0; i < this.apartmentBookingSelectList.length; i++) {
      //       let data = this.apartmentBookingSelectList[i];
      //       // }
      //       // this.apartmentBookingSelectList.forEach(data => {
      //       let checkApartmentTypeExist = this.apartmentInBookingList.findIndex(
      //         x => x.apartmentTypeId === data.id
      //       );
      //       if (checkApartmentTypeExist === -1) {
      //         let item = {
      //           id: 0,
      //           apartmentTypeId: data.id,
      //           apartmentType: data.apartmentType,
      //           adults: data.adults,
      //           children: data.children,
      //           numberOfRoomChoose: data.numberOfRoomChoose
      //         };
      //         this.apartmentInBookingList.push(item);
      //       } else {
      //         let sumApartment =
      //           parseInt(
      //             this.apartmentInBookingList[checkApartmentTypeExist]
      //               .numberOfRoomChoose
      //           ) + parseInt(data.numberOfRoomChoose);
      //         if (sumApartment > parseInt(data.quantity)) {
      //           console.log(this.apartmentInBookingList[checkApartmentTypeExist]);
      //           this.onShowError(
      //             this.apartmentBookingSelectList[checkApartmentTypeExist].quantity
      //           );
      //         } else {
      //           this.apartmentInBookingList[
      //             checkApartmentTypeExist
      //           ].numberOfRoomChoose = sumApartment;
      //         }
      //       }
      //     }
      //   }
      // }
    },
    onOpenEditApartmentBooking: function() {},
    onSearchApartmentTypeBooking: function() {
      let filter = {
        params: {
          checkInDate: this.getDateTimeCheckInAndCheckOut(
            this.apartmentBookingSearch.dateCheckIn,
            this.apartmentBookingSearch.timeCheckIn
          ),
          checkOutDate: this.getDateTimeCheckInAndCheckOut(
            this.apartmentBookingSearch.dateCheckOut,
            this.apartmentBookingSearch.timeCheckOut
          ),
          apartmentBookingId: this.apartmentBookingData.id
        }
      };
      this.GET_APARTMENT_TYPE_IN_BOOKING_LIST(filter)
        .then(
          async function(res) {
            let data = res;
            this.apartmentSearchBookingItem = [];
            data.forEach((value, index) => {
              let item = {
                id: value.id,
                nonumber: index + 1,
                apartmentType: value.name,
                adults: value.adults,
                children: value.children,
                quantity: value.apartment_count,
                numberOfRoomChoose: 0
              };
              this.apartmentSearchBookingItem.push(item);
            });
            if (this.apartmentInBookingList.length > 0) {
              await this.getRowsSelected(this.apartmentInBookingList);
            }
          }.bind(this)
        )
        .catch(function(error) {}.bind(this));
    },
    validateBookingData: function() {
      let validateResults = "OK";
      if (utils.isEmptyString(this.apartmentBookingData.dateCheckIn)) {
        validateResults = this.$t("apartmentBooking.checkInDate");
      } else if (utils.isEmptyString(this.apartmentBookingData.timeCheckIn)) {
        validateResults = this.$t("apartmentBooking.checkInTime");
      } else if (utils.isEmptyString(this.apartmentBookingData.dateCheckOut)) {
        validateResults = this.$t("apartmentBooking.checkOutDate");
      } else if (utils.isEmptyString(this.apartmentBookingData.timeCheckOut)) {
        validateResults = this.$t("apartmentBooking.checkOutTime");
      } else if (this.customerInBookingList.length === 0) {
        validateResults = this.$t("apartmentBooking.errorSelectCustomerBooking");
      } else if (this.apartmentInBookingList.length === 0) {
        validateResults = this.$t("apartmentBooking.errorSelectApartmentBookingList");
      }
      return validateResults;
    },
    getDateTimeCheckInAndCheckOut: function(dateData, timeData) {
      let result = null;
      result = dateData + " " + timeData;
      return utils.formatSqlUtcDate(result, "DD-MM-YYYY HH:mm", "YYYY-MM-DD HH:mm");
    },
    onSaveBooking: function() {
      // validate data
      let results = this.validateBookingData();
      if (results === "OK") {
        //
        let data = {
          id: this.apartmentBookingData.id,
          checkin_datetime: this.getDateTimeCheckInAndCheckOut(
            this.apartmentBookingData.dateCheckIn,
            this.apartmentBookingData.timeCheckIn
          ),
          checkout_datetime: this.getDateTimeCheckInAndCheckOut(
            this.apartmentBookingData.dateCheckOut,
            this.apartmentBookingData.timeCheckOut
          ),
          user_booking_list: this.customerInBookingList,
          apartment_booking_list: this.apartmentInBookingList
        };
        if (this.apartmentBookingData.id === 0) {
          this.CREATE_APARTMENT_BOOKING(data)
            .then(
              function() {
                this.onCallBackBookingList();
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function() {
                this.ERROR_TOAST();
              }.bind(this)
            );
        } else {
          this.UPDATE_APARTMENT_BOOKING_V2(data)
            .then(
              function() {
                this.onCallBackBookingList();
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function() {
                this.ERROR_TOAST();
              }.bind(this)
            );
        }
      } else {
        this.onShowError(results);
      }
    },
    getApartmentListInBooking: function(bookingId) {
      let filter = {
        params: {
          bookingId: bookingId
          // bookingStatusList: [BookingActionEnum.WAITING_CHECK_IN,
          //   BookingActionEnum.CHECKED_IN,
          //   BookingActionEnum.CHECK_OUT]
        }
      };
      this.GET_APARTMENT_LIST_IN_BOOKING(filter);
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_COUNTRY_LIST",
      "GET_APARTMENT_TYPE_IN_BOOKING_LIST",
      "CREATE_APARTMENT_BOOKING",
      "UPDATE_APARTMENT_BOOKING_V2",
      "GET_APARTMENT_BOOKING_DETAIL",
      "GET_APARTMENT_LIST_IN_BOOKING"
    ])
  },

  mounted() {
    // this.isLoading = true;
    // -----------------------------
    // load data
    // -----------------------------
    this.GET_COUNTRY_LIST().then(
      function(res) {
        let countries = [
          {
            value: null,
            text: "---"
          }
        ];
        let data = res.data;
        data.forEach(c => {
          let country = {
            value: c.id,
            text: c.country_name
          };
          countries.push(country);
        });
        this.countryList = countries;
      }.bind(this)
    );
    let id = this.$route.params.id;
    if (parseInt(id) !== 0) {
      this.getApartmentListInBooking(id);
      this.GET_APARTMENT_BOOKING_DETAIL({ id: id })
        .then(
          async function(res) {
            let data = res;
            this.apartmentBookingData.id = data.id;
            let checkInDateTime = moment(data.checkin_datetime);
            let checkOutDateTime = moment(data.checkout_datetime);
            // config date picker min date
            await this.onChangeMinDateCheckInDate(checkInDateTime.format("DD-MM-YYYY"));
            await this.onChangeMinDateCheckOutDate(checkInDateTime.format("DD-MM-YYYY"));
            // await this.onChangeCheckInDate(checkInDateTime.format("DD-MM-YYYY"));

            this.apartmentBookingData.dateCheckIn = checkInDateTime.format("DD-MM-YYYY");
            this.apartmentBookingData.timeCheckIn = checkInDateTime.format("HH:mm");
            this.apartmentBookingData.dateCheckOut = checkOutDateTime.format("DD-MM-YYYY");
            this.apartmentBookingData.timeCheckOut = checkOutDateTime.format("HH:mm");
            this.apartmentBookingData.status = data.status
            let userInBooking = data.user_in_booking;
            this.customerInBookingList = [];
            userInBooking.forEach((userData, index) => {
              let userItem = {
                id: userData.id,
                nonumber: index + 1,
                customerName: userData.full_name,
                customerPhone: userData.phone,
                customerEmail: userData.email,
                customerGender: userData.gender,
                identificationnumber: userData.identificationnumber,
                dateCreateIdentificationnumber:
                  userData.date_create_identificationnumber,
                customerDob: userData.dob,
                customerCountry: userData.country_code,
                customerAddress: userData.address,
                isManCustomerBooking: userData.is_main_booking
              };
              this.customerInBookingList.push(userItem);
            });
            let apartmentInBooking = data.apartment_in_booking;
            this.apartmentInBookingList = [];
            apartmentInBooking.forEach((apartmentData, index) => {
              let apartmentItem = {
                id: 0,
                nonumber: index + 1,
                apartmentTypeId: apartmentData.id,
                apartmentType: apartmentData.name,
                adults: apartmentData.adults,
                children: apartmentData.children,
                numberOfRoomChoose: apartmentData.number_of_room_choose
              };
              this.apartmentInBookingList.push(apartmentItem);
            });
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
hr.new1 {
  width: 90%;
}

.date-format {
  padding-top: 7px;
  margin-bottom: 0;
}

.case-format {
  width: 330%;
  margin-left: -16px;
}

.asset-format {
  width: 330%;
  margin-left: -16px;
}

.date-input-format {
  width: 304px;
}

@media (max-width: 789px) and (min-width: 320px) {
  .case-format {
    margin-top: 0px;
    width: 107%;
  }
  .asset-format {
    margin-top: 0px;
    width: 107%;
  }
}

/* label.required:not(:empty):after, */
/* .field-header.required:after { */
label.required:after {
  content: " *";
  color: red;
  position: absolute;
  padding-left: 8px;
  top: 0px;
}

.margin-bottom-15 {
  padding-bottom: 15px;
}

/*  */
.feedback-img-item {
  width: 100%;
  max-width: 150px;
  max-height: 200px;
  object-fit: contain;
}

.feedback-img-class {
  margin: auto;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/ApartmentBooking/BookingInfo.vue